import { useEffect } from 'react'
import mitt from 'mitt'

export default (eventName, callback) => {
  let caiEventBus = window.caiEventBus

  if (!caiEventBus) {
    let _caiEventBus

    if (typeof window !== 'undefined') {
      if (window.caiEventBus) {
        _caiEventBus = window.caiEventBus
      } else {
        _caiEventBus = window.caiEventBus = mitt()
      }
    }
  }

  useEffect(() => {
    let caiEventBus = window.caiEventBus
    if (caiEventBus) {
      caiEventBus.on(eventName, callback)

      return () => {
        caiEventBus.off(eventName, callback)
      }
    } else {
      console.warn(`caiEventBus unavailable`)
    }
  }, [caiEventBus, callback])
}
